<template lang="pug">
  button(class="pf-button icon" type="button" @click="goToPreviousStep")
    font-awesome-icon(icon="angle-left" class="mr-2")
    | {{ $t('back') }}
</template>

<script>
export default {
  name: 'BackButton',
};
</script>
